import React, { useState, useEffect, useCallback } from "react";
import { ScrollableList } from "../../Components/ScrollableList";
import { useQuery, useQueryClient } from "react-query";
import { apiUrl } from "../../Components/config";
import { useHttp, useHorizontalScroll } from "../../Hooks";
import { ResGrad } from "../../Components/interface";
import { Navigation } from "../Navigation";
import { LoadingPage } from "../LoadingPage";

const tierList = [
  { name: "A", label: "Galaxy", description: "MC MORE THAN 5000ETH" },
  { name: "B", label: "Star", description: "MC 500ETH - 5000ETH" },
  { name: "C", label: "Planet", description: "MC 100ETH - 500ETH" },
  { name: "D", label: "Asteroid", description: "MC 50ETH - 100ETH" },
  { name: "E", label: "Meteor", description: "MC 10ETH - 50ETH" },
  { name: "F", label: "Supernova", description: "MC WITHIN 10ETH" },
];

export const Tiers = () => {
  const client = useHttp();
  const {
    data: apiData,
    isLoading,
    isError,
    status,
  } = useQuery<ResGrad, string>(["grad"], () => {
    return client("grad", { url: apiUrl });
  });

  const {
    containerRef,
    showArrows,
    canScrollLeft,
    canScrollRight,
    checkScroll,
    startScrolling,
    stopScrolling,
  } = useHorizontalScroll();

  return (
    <>
      {isLoading && <LoadingPage text="Loading NFTs Search Engines" />}
      <div
        className={`page-content ${!isLoading ? "loaded left-nav-sidebar" : ""}`}
      >
        <Navigation name="tiers" />
        <div className="tiers">
          <div className="tiers-container">
            {tierList.map((tier, index) => {
              return <ScrollableList key={index} tier={tier} items={apiData} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
};
